interface MultilinePreviewProps {
	showLineNumbers?: boolean
	value: string
}

export const MultilinePreview = ({
	value,
	showLineNumbers = false,
}: MultilinePreviewProps) => {
	const lines = value.split('\n')

	return (
		<div className="text-xs max-w-[500px]">
			{lines.map((line, index) => (
				<div key={index} className="flex">
					{showLineNumbers && (
						<span className="text-gray-500 select-none w-6 text-right pr-2 shrink-0">
							{index + 1}
						</span>
					)}
					<span className="whitespace-pre">{line || ' '}</span>
				</div>
			))}
		</div>
	)
}
